import PropTypes from 'prop-types';
import React from 'react';
import Style from './style.scss';
import ScItem from './scItem';
import DynamicLink from '../utils/DynamicLink/index';
import C from '../../constants/serviceCatalog';
import {openFaq, openWindow} from '../../utils/helpers';
import {getNavigationProps} from '../utils/DynamicLink/linkHelper'

export const uniqueLinks = ['passwordServices', 'calendar', 'faq', 'chat', 'myDesktop'];

class ScLink extends React.Component {
  constructor(props) {
    super(props);
    this.navigation = getNavigationProps(this.props.id);
  }

  render() {
    if (uniqueLinks.includes(this.props.uniqueName)) {
      return (
        <a
          href="javascript:;"
          className={Style.empty}
          onClick={() => {
            openWindow(this.props.targetUrl, this.props.uniqueName);
          }}
        >
          <ScItem {...this.props} />
        </a>
      );
    } else if (this.props.type === C.FAQ_ITEM) {
      return (
        <a
          href="javascript:;"
          className={Style.empty}
          onClick={() => openFaq(this.props.id, 'FAQfromSSP')}
        >
          <ScItem {...this.props} />
        </a>
      );
    } else {
      const target =
        this.props.openingMethod === C.NEW_WINDOW ? '_blank' : '_self';

      return (
        <DynamicLink
          className={Style.empty}
          to={this.props.targetUrl || this.navigation[this.props.type]}
          target={target}
        >
          <ScItem {...this.props} />
        </DynamicLink>
      );
    }
  }
}

ScLink.propTypes = {
  name: PropTypes.string,
  intlObject: PropTypes.object.isRequired,
  uniqueName: PropTypes.string, //.isRequired,
  type: PropTypes.string, //.isRequired,
  openingMethod: PropTypes.string, //.isRequired,
  id: PropTypes.number, //.isRequired,
  reportAnalytics: PropTypes.func.isRequired,
  targetUrl: PropTypes.string //.isRequired
};
export default ScLink;



// WEBPACK FOOTER //
// ./components/ServiceCatalog/scLink.js